// removed by extract-text-webpack-plugin
module.exports = {"container":"target__container___2EvPW","target":"target__target___3VcyP"};


//////////////////
// WEBPACK FOOTER
// ./components/Target/target.css
// module id = 274
// module chunks = 0